import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "@/context/AuthContext"

export const ProtectedRoute = ({ children }) => {
  const { authStatus, isLoading } = useAuth()
  const location = useLocation()

  // 1. 正在加载权限信息
  if (isLoading) {
    return <div>Checking permissions...</div>
  }

  // 2. 未登录
  if (authStatus === "unauthenticated") {
    return <Navigate to="/inner-page" replace state={{ from: location }} />
  }

  // 4. 所有检查通过，渲染页面
  return children
}

